import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { StrikeWeightDesignMode, type StrikeWeightDesignTarget } from '@/lib/piano/touch-design/design/strike-weight-design';
import { useDesignActions, useStrikeWeightDesign } from '@/hooks/store/use-design-store';
export const useStrikeWeightTargetSelector = () => {
  const $ = _c(14);
  const {
    strikeWeightDesignComputedBalanceWeightTarget,
    strikeWeightDesignMode,
    strikeWeightDesignSmoothTarget,
    strikeWeightDesignStandarTarget,
    strikeWeightDesignTarget
  } = useStrikeWeightDesign();
  const {
    updateStrikeWeightDesign
  } = useDesignActions();
  let t0;
  if ($[0] !== strikeWeightDesignMode || $[1] !== updateStrikeWeightDesign) {
    t0 = target => {
      updateStrikeWeightDesign(strikeWeightDesignMode, target);
    };
    $[0] = strikeWeightDesignMode;
    $[1] = updateStrikeWeightDesign;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onTargetChange = t0;
  let t1;
  if ($[3] !== strikeWeightDesignComputedBalanceWeightTarget || $[4] !== strikeWeightDesignSmoothTarget || $[5] !== strikeWeightDesignStandarTarget || $[6] !== updateStrikeWeightDesign) {
    t1 = mode => {
      if (mode === StrikeWeightDesignMode.StandardCurves) {
        updateStrikeWeightDesign(mode, strikeWeightDesignStandarTarget);
      } else {
        if (mode === StrikeWeightDesignMode.Smoothed) {
          updateStrikeWeightDesign(mode, strikeWeightDesignSmoothTarget);
        } else {
          if (mode === StrikeWeightDesignMode.Computed) {
            updateStrikeWeightDesign(mode, strikeWeightDesignComputedBalanceWeightTarget);
          } else {
            updateStrikeWeightDesign(mode, null);
          }
        }
      }
    };
    $[3] = strikeWeightDesignComputedBalanceWeightTarget;
    $[4] = strikeWeightDesignSmoothTarget;
    $[5] = strikeWeightDesignStandarTarget;
    $[6] = updateStrikeWeightDesign;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const onModeChange = t1;
  let t2;
  if ($[8] !== onModeChange || $[9] !== onTargetChange || $[10] !== strikeWeightDesignMode || $[11] !== strikeWeightDesignTarget || $[12] !== updateStrikeWeightDesign) {
    t2 = {
      onModeChange,
      onTargetChange,
      strikeWeightDesignMode,
      strikeWeightDesignTarget,
      updateStrikeWeightDesign
    };
    $[8] = onModeChange;
    $[9] = onTargetChange;
    $[10] = strikeWeightDesignMode;
    $[11] = strikeWeightDesignTarget;
    $[12] = updateStrikeWeightDesign;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};